import { observer } from 'mobx-react'
import { useEffect, useState } from 'react'

import { _OldButton } from '@/component/atoms/Button/_OldButton'
import useRepository from '@/hooks/useRepository'
import b2gContractService from '@/service/b2gContract.service'
import { CustomEventService } from '@/service/customEvent.service'
import modalService from '@/service/modal.service'
import { commonErrorMessage, toastError } from '@/utils/toast'

import type { ModalProps } from '../ContractModal'
import { ContractModalService } from '../ContractModal.service'
import { S } from '../ContractModal.style'

const ContractStep3 = ({ onClick }: ModalProps) => {
  const service = useRepository(ContractModalService)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (!b2gContractService.pdfStatus || !b2gContractService.isGenerating) {
      CustomEventService.스쿨플랫계약서생성상태.listen((e) => {
        b2gContractService.setPdfStatus(e.detail)
      })
    }
  }, [b2gContractService])

  return (
    <S.ModalStep3>
      <strong>
        제출 후 계약서 내용 수정이 불가능합니다. <br />
        정말 제출하시겠습니까?
      </strong>
      <p>관리자 계정의 ‘내 정보'에서 계약 내역서를 다운로드 받으실 수 있습니다.</p>
      <div className="button-wrap">
        <_OldButton width={100} height={40} onClick={() => service.uiStore.goPrevStep()}>
          돌아가기
        </_OldButton>
        <_OldButton
          loading={isLoading}
          theme="primary"
          width={100}
          height={40}
          onClick={async (e) => {
            try {
              setIsLoading(true)
              await service.submitContract()
              modalService.closeModal()
              onClick?.(e)
            } catch (e) {
              toastError('계약서 제출에 실패했습니다.')
              commonErrorMessage(e)
            } finally {
              setIsLoading(false)
            }
          }}
        >
          확인
        </_OldButton>
      </div>
    </S.ModalStep3>
  )
}

export default observer(ContractStep3)
